import { createApp } from 'vue'
import { createStore } from 'vuex'
import App from './App.vue'
import router from './router'
import config from './config'
import gtag from 'vue-gtag-next';

var jwt = require('jsonwebtoken');

// Create a new store instance.
const store = createStore({
    state () {
        return {
            availableFilters: {
                quick_filters: {
                    authRequired: false,
                    name: "quick_filters",
                    type: "quick",
                    displayString: "Quick Filters",
                    icon: "quick_filters.png",
                    default: {},
                    selected: {}
                },
                vehicle_types: {
                    authRequired: false,
                    name: "vehicle_types",
                    type: "array",
                    displayString: "Vehicle Types",
                    icon: "vehicle_types.png",
                    default: [],
                    selected: []
                },
                makes: {
                    authRequired: false,
                    name: "makes",
                    type: "array",
                    displayString: "Makes",
                    icon: "makes.png",
                    default: [],
                    selected: []
                },
                models: {
                    authRequired: false,
                    name: "models",
                    type: "object",
                    displayString: "Models",
                    icon: "models.png",
                    default: {},
                    available: {},
                    selected: {}
                },
                price: {
                    authRequired: false,
                    name: "price",
                    type: "range",
                    displayString: "Price Range",
                    icon: "price.png",
                    default: {},
                    selected: {min: null, max: null}
                },
                year: {
                    authRequired: false,
                    name: "year",
                    type: "range",
                    displayString: "Year Range",
                    icon: "year.png",
                    default: {},
                    selected: {min: null, max: null}
                },
                mileage: {
                    authRequired: false,
                    name: "mileage",
                    type: "range",
                    displayString: "Mileage",
                    icon: "mileage.png",
                    default: {},
                    selected: {min: null, max: null}
                },
                colors: {
                    authRequired: false,
                    name: "colors",
                    type: "array",
                    displayString: "Colors",
                    icon: "colors.png",
                    default: [],
                    selected: []
                },
                options: {
                    authRequired: false,
                    name: "options",
                    type: "array",
                    displayString: "Options",
                    icon: "options.png",
                    default: {
                        all_wheel: 'All Wheel', 
                        automatic: 'Automatic',
                        awd: 'AWD',
                        backup_camera: 'Backup Camera',
                        crew_cab: 'Crew Cab',
                        diesel: 'Diesel',
                        extended_cab: 'Extended Cab',
                        four: 'Four',
                        fwd: 'FWD',
                        leather: 'Leather',
                        manual: 'Manual',
                        moonroof: 'Moonroof',
                        navigation: 'Navigation',
                        none: 'None',
                        rear_entertainment: 'Rear Entertainment',
                        regular_cab: 'Regular Cab',
                        rwd: 'RWD',
                        third_row: 'Third Row',
                        unspecified: 'Unspecified',
                        t_wheel_dr: '2 Wheel Dr',
                        f_wheel_dr: '4 Wheel Dr',
                        fourWD: '4WD',
                        two_door: '2 Door',
                        three_door: '3 Door',
                        four_door: '4 Door'
                    },
                    selected: []
                },
                acv: {
                    authRequired: true,
                    name: "acv",
                    type: "range",
                    displayString: "ACV",
                    icon: "acv.png",
                    default: {},
                    selected: {min: null, max: null}
                },
                back_of_book: {
                    authRequired: true,
                    name: "back_of_book",
                    type: "range",
                    displayString: "Back of Book",
                    icon: "back_of_book.png",
                    default: {},
                    selected: {min: null, max: null}
                },
                buy_now: {
                    authRequired: true,
                    name: "buy_now",
                    type: "boolean",
                    displayString: "Buy Now",
                    icon: "buy_now.png",
                    default: false,
                    selected: false
                }
            },
            availableSortColumns: {
                order: ['Miles','PriceToShow','Year','ExteriorColor','Drive','Transmission','EngineSize','InteriorColor','Options','BOB','ACV'],
                mobileOrder: ['Miles','PriceToShow','Year','BOB','ACV'],
                ACV: {
                    display: 'ACV',
                    authRequired: true,
                    sortable: true,
                    defaultDirectionDesc: true
                },
                BOB: {
                    display: 'BoB',
                    authRequired: true,
                    sortable: false, //true,
                    defaultDirectionDesc: false
                },
                Miles: {
                    display: 'Miles',
                    authRequired: false,
                    sortable: true,
                    defaultDirectionDesc: true
                },
                Year: {
                    display: 'Year',
                    authRequired: false,
                    sortable: true,
                    defaultDirectionDesc: true
                },
                PriceToShow: {
                    display: 'Price',
                    authRequired: false,
                    sortable: true,
                    defaultDirectionDesc: true
                },
                InteriorColor: {
                    display: 'Int Color',
                    authRequired: false,
                    sortable: false
                },
                ExteriorColor: {
                    display: 'Ext Color',
                    authRequired: false,
                    sortable: false
                },
                EngineSize: {
                    display: 'Engine',
                    authRequired: false,
                    sortable: false
                },
                Drive: {
                    display: 'Drive',
                    authRequired: false,
                    sortable: false
                },
                Transmission: {
                    display: 'Trans',
                    authRequired: false,
                    sortable: false
                },
                Options: {
                    display: 'Options',
                    authRequired: false,
                    sortable: false
                }
            },
            quickFilters: {
                qfUnder30: {
                    name: "qfUnder30",
                    display: "Under $30,000 with free lifetime mechanical warranty",
                    filters: {
                        price: {min: 0, max: 30000},
                        year: {min: ((new Date).getFullYear() - 19)},
                        mileage: {min: 0, max: 99000},
                        buy_now: true
                    },
                    placement: "modal"
                },
                qfNealyNew: {
                    name: "qfNealyNew",
                    display: "Nearly New Chevrolets",
                    filters: {
                        makes: ['Chevrolet'],
                        year: {min: ((new Date).getFullYear() - 2)},
                        mileage: {min: 0, max: 30000}
                    },
                    placement: "modal"
                },
                qfNearlyNewGM: {
                    name: "qfNearlyNewGM",
                    display: "Nearly New GM Vehicles (Buick, Cadillac, and GMC)",
                    filters: {
                        makes: ['Buick', 'Cadillac', 'GMC'],
                        year: {min: ((new Date).getFullYear() - 2)},
                        mileage: {min: 0, max: 30000}
                    },
                    placement: "modal"
                },
                /*qfOnlineCarsValue: {
                    name: "qfOnlineCarsValue",
                    display: "Value Vehicles",
                    filters: {
                        buy_now: true
                    }
                },*/ 
                qfABCredit: {
                    name: "qfABCredit",
                    display: "A/B Credit Guest",
                    filters: {
                        year: {min: ((new Date).getFullYear() - 11)},
                        mileage: {min: 0, max: 99000},
                        buy_now: true
                    },
                    placement: "modal"
                },
                qfThirdRow: {
                    name: "qfThirdRow",
                    qfThirdRow: "qfThirdRow",
                    display: "3rd Row Seating",
                    filters: {
                        options: ['Third Row'],
                    },
                    placement: "modal"
                },
                qfFreeLifetimeWarrantry: {
                    name: "qfFreeLifetimeWarrantry",
                    display: "Free Lifetime Warranty", //Mechanical Warranty Vehicles",
                    filters:{
                        year: {min: ((new Date).getFullYear() - 19)},
                        mileage: {min: 0, max: 99000},
                        buy_now: true
                    },
                    placement: "wrapper"
                }
            },
            authUser:{},
            query: {},
            initial_query: true,
            default_sort_col: 'BOB',
            default_sort_reverse: false,
            sort_col: null,
            sort_reverse: null,
            messageToGuest: "",
            loggedIn: false,
            inMobileView: false,
            needsTabletStyling: false,
            orientation: "",
            filterSelectOpen: "",
            matches_total: 0,
            matches: [],
            totalVehicleCount: 0,
            searchQueryHasChanges: false,
            queryRunning: false,
            dest_zip: window.localStorage.DestZip ? JSON.parse(window.localStorage.DestZip) : { zip: 45249, city: 'Cincinnati', state: 'OH'},
            destZipSearch: "",
            search_text: "",
            pageLimit: 50,
            current_page: 0,
            column_acv_collapsed: false,
            column_bob_collapsed: false,
            selected_vins: [],
            suggestedZips: null,
            generatingSpreadsheet: false,
            spreadsheetFormOpen: false,
            loggingIn: false,
            loginFormVisible: false,
            loginErrorMsg: "",
            openGalleryImages: [],
            vdpVehicleSelected: null,
            productSpecialists: [],
            queryFailure: false,
            displayMobileResults: false,
            mobileKeyboardOpen: false,
            //welcomePopupOpen: true,
            routerQueryStringChange: false,
            browserButtonActionRunning: false,
            queryHasMatches: true,
            resizeCount: 0,
            crashMarkInitiated: null,
            youtubePlayerReady: false,
            youtubeVideoPlaying: false,
            appUrls: null,
            autocheckDocHeight: null,
            vehicleShareFormOpen: false,
            defaultDeliveryLocation: window.localStorage.DeliveryLocation ? JSON.parse(window.localStorage.DeliveryLocation) : {},
            associatedAdessaDeliveryLocations: {},
            deliveryLocationSort: {field: 'distance', direction: 'ASC'},
            currentDeliveryLocationDisplayOpen: false,
            vehiclesRemoved: 0,
            deliveryLocationSelectOpenStatus: false,
            gubagooConversationsURL: "https://app.gubagoo.com/login",
            searchScrollPosition: 0
        }
    },
    getters: {
        queryCount (state) {
            return state.matches_total;
        },
        isMobile (state) {
            return state.inMobileView;
        },
        isTablet (state) {
            return state.needsTabletStyling;
        },
        getOrientation (state) {
            return state.orientation;
        },
        isLoggedIn (state) {
            return state.loggedIn;
        },
        getAuthUser (state) {
            return state.authUser;
        },
        getAvailableSortColumns (state) {
            return state.availableSortColumns;
        },
        getAvailablSortColumnNames (state) {
            let sortColNamesBasedOnAuthStatus = [];
            let availableSortCols = state.inMobileView ? state.availableSortColumns.mobileOrder : state.availableSortColumns.order;

            if(state.loggedIn) {
                sortColNamesBasedOnAuthStatus = availableSortCols;
            }
            else {
                for(let c = 0; c < availableSortCols.length; c++) {
                    let colName = availableSortCols[c];

                    if(!state.availableSortColumns[colName].authRequired) {
                        sortColNamesBasedOnAuthStatus.push(colName);
                    }
                }
            }

            return sortColNamesBasedOnAuthStatus;
        },
        getAvailablSortColumnByName: (state) => (colName) => {
            return state.availableSortColumns[colName];
        },
        getQuickFilters (state) {
            return state.quickFilters;
        },
        getAvailableFilters (state) {
            return state.availableFilters;
        },
        getFilterSelectedByName: (state) => (filterName) => {
            return state.availableFilters[filterName].selected;
        },
        getSelectedOfObjectTypeFilterByName: (state) => (filterName) => {
            let setSelected = [];

            for(const key in state.availableFilters[filterName].selected) {
                for(var k = 0; k < state.availableFilters[filterName].selected[key].length; k++) {
                    let sub = state.availableFilters[filterName].selected[key][k];
                    setSelected.push(sub);
                }
            }

            return setSelected;
        },
        isFilterSelectOpen (state) {
            return (state.filterSelectOpen != "");
        },
        getFilterSelectOpen (state) {
            return state.filterSelectOpen;
        },
        getTotalVehicleCount (state) {
            return state.totalVehicleCount;
        },
        getTotalMatches (state) {
            return state.matches_total;
        },
        getMatches (state) {
            return state.matches;
        },
        isVinSelected: (state) => (vin) => {
            return state.selected_vins.includes(vin);
        },
        doesSearchQueryHaveChanges (state) {
            return state.searchQueryHasChanges;
        },
        isQueryRunning (state) {
            return state.queryRunning;
        },
        getDestZip (state) {
            return state.dest_zip;
        },
        getDestZipSearch (state) {
            return state.destZipSearch;
        },
        getSearchText (state) {
            return state.search_text;
        },
        getLowMilageStatus (state) {
            return state.availableFilters['mileage'].selected.max < 10000;
        },
        getQuery (state) {
            return state.query;
        },
        isSpreadsheetFormVisible (state) {
            return state.spreadsheetFormOpen;
        },
        getPageLimit (state) {
            return state.pageLimit;
        },
        getCurrentPage (state) {
            return state.current_page;
        },
        nextPageStart (state) {
            return (state.current_page * state.pageLimit) - state.vehiclesRemoved;
        },
        getCabTypesSelected (state) {
            let cabTypesSelected = [];

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['regular_cab'])) {
                cabTypesSelected.push('Regular');
            }

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['crew_cab'])) {
                cabTypesSelected.push('Crew');
            }

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['extended_cab'])) {
                cabTypesSelected.push('Extended');
            }

            return cabTypesSelected;
        },
        getDoorsSelected (state) {
            let doorsSelected = [];

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['two_door'])) {
                doorsSelected.push('2');
            }

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['three_door'])) {
                doorsSelected.push('3');
            }

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['four_door'])) {
                doorsSelected.push('4');
            }

            return doorsSelected;
        },
        getTransmisionSelected (state) {
            let transSelected = [];

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['automatic'])) {
                transSelected.push('automatic');
            }

            if(state.availableFilters['options'].selected.includes(state.availableFilters['options'].default['manual'])) {
                transSelected.push('manual');
            }

            return transSelected;
        },
        getDriveSelected (state) {
            let driveSelected = [];
            let possibleDriveOptions = ['FWD','AWD','4 Wheel Dr','None','All Wheel','2 Wheel Dr','Four','RWD','4WD','Unspecified'];

            possibleDriveOptions.forEach(function(drive) {
                if(state.availableFilters['options'].selected.includes(drive)) {
                    driveSelected.push(drive);
                }
            })

            return driveSelected;
        },
        getVechicleTypesSelected (state) {
            let expandedVehicleTypes = [];

            if(state.availableFilters['vehicle_types'].selected.includes('Van')) {
                expandedVehicleTypes = expandedVehicleTypes.concat(['Van']);
            }

            if(state.availableFilters['vehicle_types'].selected.includes('Car')) {
                expandedVehicleTypes = expandedVehicleTypes.concat(['Car','Large Car','Mid-size Car','Small Car']);
            }

            if(state.availableFilters['vehicle_types'].selected.includes('SUV')) {
                expandedVehicleTypes = expandedVehicleTypes.concat(['SUV','Small MPV','Mid-size MPV','Full-size MPV','MPV']);
            }

            if(state.availableFilters['vehicle_types'].selected.includes('Truck')) {
                expandedVehicleTypes = expandedVehicleTypes.concat(['Full-size Pickup','Mini Pickup','Truck','Medium Duty Truck','Heavy Duty Truck']);
            }

            return expandedVehicleTypes;
        },
        isColumnAcvCollapsed (state) {
            return state.column_acv_collapsed;
        },
        isColumnBobCollapsed (state) {
            return state.column_bob_collapsed;
        },
        getSelectedVins (state) {
            return state.selected_vins;
        },
        getSortColumn (state) {
            return state.sort_col ? state.sort_col : state.default_sort_col;
        },
        getSortDirection (state) {
            return state.sort_col ? state.sort_reverse : state.default_sort_reverse;
        },
        getDeafultSortCol (state) {
            return state.default_sort_col;
        },
        getSuggestedZips (state) {
            return state.suggestedZips;
        },
        isSpreadsheetGenerating (state) {
            return state.generatingSpreadsheet;
        },
        isLoggingIn (state) {
            return state.loggingIn;
        },
        isLoginFormVisible (state) {
            return state.loginFormVisible;
        },
        getLoginErrorMsg (state) {
            return state.loginErrorMsg;
        },
        getAuthUserFullName (state) {
            if(state.loggedIn) {
                return state.authUser.first_name + " " + state.authUser.last_name;
            }
        },
        getOpenGalleryImages (state) {
            if(state.openGalleryImages && state.openGalleryImages.length > 1) {
                return state.openGalleryImages;
            }
            else {
                return [];
            }
        },
        vehicleGallerySelected (state) {
            return state.vdpVehicleSelected;
        },
        getProductSpecialistsList (state) {
            return state.productSpecialists;
        },
        getMessageToGuest (state) {
            return state.messageToGuest;
        },
        getQueryFailure (state) {
            return state.queryFailure;
        },
        showMobileVehicleResults (state) {
            return state.displayMobileResults;
        },
        isMobileKeyboardOpen (state) {
            return state.mobileKeyboardOpen;
        },
        /* (state) {
            return state.welcomePopupOpen;
        },*/
        translateQueryStringCabTypes : (state) => (cabTypes) => {
            let optionCabTypes = [];

            if(typeof(cabTypes) == 'object') {
                for(var c = 0; c < cabTypes.length; c++) {
                    optionCabTypes.push(state.availableFilters['options'].default[cabTypes[c]]);
                }
            }
            else {
                optionCabTypes.push(state.availableFilters['options'].default[cabTypes]);
            }
            
            return optionCabTypes;
        },
        translateQueryStringTransmissionTypes : (state) => (transmissionTypes) => {
            let optionTransmissionTypes = [];

            if(typeof(transmissionTypes) == 'object') {
                for(var c = 0; c < transmissionTypes.length; c++) {
                    optionTransmissionTypes.push(state.availableFilters['options'].default[transmissionTypes[c]]);
                }
            }
            else {
                optionTransmissionTypes.push(state.availableFilters['options'].default[transmissionTypes]);
            }
            
            return optionTransmissionTypes;
        },
        translateQueryStringDriveTypes : (state) => (driveTypes) => {
            let optionDriveTypes = [];

            if(typeof(driveTypes) == 'object') {
                for(var c = 0; c < driveTypes.length; c++) {
                    optionDriveTypes.push(state.availableFilters['options'].default[driveTypes[c]]);
                }
            }
            else {
                optionDriveTypes.push(state.availableFilters['options'].default[driveTypes]);
            }

            return optionDriveTypes;
        },
        translateQueryStringDoorTypes : (state) => (doorTypes) => {
            let optionDoorTypes = [];

            if(typeof(doorTypes) == 'object') {
                for(var c = 0; c < doorTypes.length; c++) {
                    optionDoorTypes.push(state.availableFilters['options'].default[doorTypes[c]]);
                }
            }
            else {
                optionDoorTypes.push(state.availableFilters['options'].default[doorTypes]);
            }

            return optionDoorTypes;
        },
        translateQueryStringModels : (state) => (modelsSelected, makesSelected) => {
            let selectedModels = {};
            let makes = [].concat(makesSelected);
            let makeModelsDefault = Object.keys(state.availableFilters['models'].default).length > 0 ? state.availableFilters['models'].default 
                                        : (window.localStorage.getItem('MakeModels') ? JSON.parse(window.localStorage.getItem('MakeModels')) : null);

                                        console.log(JSON.stringify(makeModelsDefault));
            if(makeModelsDefault) {
                if(makes.length > 0) {
                    for(var model = 0; model < modelsSelected.length; model++) {
                        for(var make = 0; make < makes.length; make++) {
                            if(makeModelsDefault[makes[make]].includes(modelsSelected[model])) {
                                let makesModels = []

                                if(Object.keys(selectedModels).includes(makes[make])) {
                                    makesModels = selectedModels[makes[make]];
                                }

                                makesModels.push(modelsSelected[model]);
                                selectedModels[makes[make]] = makesModels;
                            }
                        }
                    }
                }
            }
            else {
                console.log("NO DEFAULT MAKES AND MODELS AVAILABLE YET");
            }

            return selectedModels;
        },
        getRouterQueryStringChange (state) {
            return state.routerQueryStringChange;
        },
        isBrowserButtonActionRunning (state) {
            return state.browserButtonActionRunning;
        },
        doesQueryHaveMatches (state) {
            return state.queryHasMatches;
        },
        getResizeCount (state) {
            return state.resizeCount;
        },
        hasCrashMarkBeenInitiated (state) {
            return state.crashMarkInitiated != null;
        },
        getCrashedVehicle (state) {
            return state.crashMarkInitiated;
        },
        isYoutubePlayerReady (state) {
            return state.youtubePlayerReady;
        },
        isYoutubeVideoPlaying (state) {
            return state.youtubeVideoPlaying;
        },
        getAppUrlByName : (state) => (urlName) => {
            console.log("APP URLS " + JSON.stringify(state.appUrls));
            return state.appUrls[urlName];
        },
        getAutocheckDocHeight (state) {
            return state.autocheckDocHeight;
        },
        isVehicleShareFormOpen (state) {
            return state.vehicleShareFormOpen;
        },
        getDefaultDeliveryLocation (state) {
            return state.defaultDeliveryLocation; //state.associatedAdessaDeliveryLocations[state.defaultDeliveryLocation];
        },
        getDeliveryLocations (state) {
            return state.associatedAdessaDeliveryLocations;
        },
        getDeliveryLocationSortBy (state) {
            return state.deliveryLocationSort;
        },
        getDeliveryLocationsSorted (state) {
            let sortField = state.deliveryLocationSort.field;
            let sortDirection = state.deliveryLocationSort.direction;
            let orderedDeliveryLocations = JSON.parse(JSON.stringify(state.associatedAdessaDeliveryLocations));

            if(orderedDeliveryLocations && orderedDeliveryLocations.length > 0) {
                orderedDeliveryLocations.sort(function(a, b) {
                    if(sortDirection == 'ASC') {
                        return b[sortField] < a[sortField] ? 1 : (b[sortField] == a[sortField] ? (b.site_name < a.site_name ? 1 : -1) : -1);
                    }
                    else if(sortDirection == 'DESC') {
                        return b[sortField] > a[sortField] ? 1 : (b[sortField] == a[sortField] ? (b.site_name > a.site_name ? 1 : -1) : -1);
                    }
                });
            }

            return orderedDeliveryLocations;
        },
        isCurrentDeliveryLocationDisplayOpen (state) {
            return state.currentDeliveryLocationDisplayOpen;
        },
        isVin : (state) => (vehicleId) => {
            console.log(state.LoggedIn);
            return !vehicleId.includes('_');
        },
        getDeliveryLocationSelectOpenStatus(state) {
            return state.deliveryLocationSelectOpenStatus;
        },
        getSearchScrollPosition(state) {
            return state.searchScrollPosition;
        }
    },
    mutations: {
        updateFilterSelection (state, filterSelection) {
            let availableFiltersCopy = JSON.parse(JSON.stringify(state.availableFilters));

            availableFiltersCopy[filterSelection.name].selected = filterSelection.selected;
            state.availableFilters = availableFiltersCopy;
        },
        toggleListFilterSelection (state, filterSelection) {
            if(state.availableFilters[filterSelection.name].selected.length > 0) {
                let newSelectionList = JSON.parse(JSON.stringify(state.availableFilters[filterSelection.name].selected));

                if(newSelectionList.includes(filterSelection.selection)) {
                    let removalIndex = newSelectionList.indexOf(filterSelection.selection);
                    newSelectionList.splice(removalIndex, 1);

                    if(filterSelection.name == 'makes') {
                        let newModelsAvailable = state.availableFilters['models'].available;
                        let newModelsSelected = state.availableFilters['models'].selected

                        delete newModelsAvailable[filterSelection.selection];

                        if(Object.keys(newModelsAvailable).length == 0) {
                            state.availableFilters['models'].available = JSON.parse(JSON.stringify(state.availableFilters['models'].default));
                        }
                        else {
                            state.availableFilters['models'].available = newModelsAvailable;
                        }

                        delete newModelsSelected[filterSelection.selection];
                        state.availableFilters['models'].selected = newModelsSelected;
                    }
                }
                else {
                    newSelectionList.push(filterSelection.selection);

                    if(filterSelection.name == 'makes') {
                        let modelsLimit = state.availableFilters['models'].default[filterSelection.selection];
                        let newAvailable = JSON.parse(JSON.stringify(state.availableFilters['models'].available));
                        newAvailable[filterSelection.selection] = modelsLimit;

                        state.availableFilters['models'].available = newAvailable;
                    }
                }

                state.availableFilters[filterSelection.name].selected = newSelectionList;
            }
            else {
                state.availableFilters[filterSelection.name].selected = [filterSelection.selection];

                if(filterSelection.name == 'makes') {
                    let modelsLimit = state.availableFilters['models'].default[filterSelection.selection];
                    let newAvailable = {};
                    
                    newAvailable[filterSelection.selection] = modelsLimit
                    state.availableFilters['models'].available = newAvailable;
                }
            }
        },
        toggleObjectFilterSelection (state, filterSelection) {
            if(Object.keys(state.availableFilters[filterSelection.name].selected).length > 0) {
                let updatedSelected = JSON.parse(JSON.stringify(state.availableFilters[filterSelection.name].selected));
                
                if(filterSelection.selection in updatedSelected) {
                    if(updatedSelected[filterSelection.selection].includes(filterSelection.subSelection)) {
                        let removalIndex = updatedSelected[filterSelection.selection].indexOf(filterSelection.subSelection);
                        updatedSelected[filterSelection.selection].splice(removalIndex, 1);

                        if(updatedSelected[filterSelection.selection].length == 0) {
                            delete updatedSelected[filterSelection.selection]
                        }
                    }
                    else {
                        updatedSelected[filterSelection.selection].push(filterSelection.subSelection);
                    }
                }
                else {
                    updatedSelected[filterSelection.selection] = [];
                    updatedSelected[filterSelection.selection].push(filterSelection.subSelection);
    
                    if(filterSelection.name == 'models' && (state.availableFilters['makes'].selected.length == 0)) {
                        state.availableFilters['makes'].selected = [filterSelection.selection];
                    }
                    else {
                        let makes = JSON.parse(JSON.stringify(state.availableFilters['makes'].selected));

                        makes.push(filterSelection.selection);
                        state.availableFilters['makes'].selected = makes;
                    }
                }

                state.availableFilters[filterSelection.name].selected = updatedSelected;
            }
            else {
                let newSelected = {[filterSelection.selection]: []};
                newSelected[filterSelection.selection].push(filterSelection.subSelection);

                state.availableFilters[filterSelection.name].selected = newSelected;

                if(filterSelection.name == 'models') {
                    if(state.availableFilters['makes'].selected.length == 0) {
                        state.availableFilters['makes'].selected = [filterSelection.selection];
                    }
                    else if(!state.availableFilters['makes'].selected.includes(filterSelection.selection)) {
                        let makesSelected = JSON.parse(JSON.stringify(state.availableFilters['makes'].selected));

                        makesSelected.push(filterSelection.selection);
                        state.availableFilters['makes'].selected = makesSelected;
                    }
                }
            }
        },
        setRangeMinSelected (state, update) {
            let newRange = {min: update.value, max: state.availableFilters[update.name].selected.max};
            state.availableFilters[update.name].selected = newRange;
        },
        setRangeMaxSelected (state, update) {
            let newRange = {min: state.availableFilters[update.name].selected.min, max: update.value};
            state.availableFilters[update.name].selected = newRange;
        },
        setFilterDefault (state, filterDefault) {
            state.availableFilters[filterDefault.name].default = filterDefault.default;

            if(filterDefault.name == 'mileage') {
                state.availableFilters[filterDefault.name].default.max = 300000;
            }   

            if(filterDefault.type == 'object') {
                state.availableFilters[filterDefault.name].available = filterDefault.default;
            }
        },
        setMessageToGuest (state, message) {
            state.messageToGuest = message;
        },
        updateView (state, inMobile) {
            state.inMobileView = inMobile;
        },
        updateTabletStyling (state, tabletStylying) {
            state.needsTabletStyling = tabletStylying;
        },
        updateOrientation (state, orientation) {
            state.orientation = orientation;
        },
        updateFilterSelectOpen (state, openFilter) {
            state.filterSelectOpen = openFilter;
            state.spreadsheetFormOpen = false;
        },
        setQueryResults (state, queryResults) {
            if(queryResults.total_count) {
                state.matches = queryResults.results;
                state.matches_total = queryResults.total_count;

                if(state.totalVehicleCount == 0) {
                    state.totalVehicleCount = queryResults.total_count;
                }

                state.queryHasMatches = (queryResults.total_count == 0);
            }
            else {
                let newMatchSet = JSON.parse(JSON.stringify(state.matches)).concat(queryResults.results);
                state.matches = newMatchSet;
            }
        },
        notifySearchQueryChanges (state, hasChanges) {
            console.log("NOTIFY SESRCH QUERY HAS CHANGES " + hasChanges);
            if(hasChanges) {
                state.current_page = 0;
                state.vehiclesRemoved = 0;
            }

            state.searchQueryHasChanges = hasChanges;
        },
        notifyQueryRunningState (state, isRunning) {
            state.queryRunning = isRunning;
        },
        updateDestZipSearch (state, zipSearch) {
            state.destZipSearch = zipSearch;
        },
        setSuggestedZips (state, suggested) {
            suggested.forEach(function(zip) {
                let cammelCaseCity = "";
                let cityParts = zip.city.split(" ");

                for(let c = 0; c < cityParts.length; c++) {
                    let firstLetter = cityParts[c].slice(0,1);
                    let remainder = cityParts[c].slice(1);

                    cammelCaseCity += c > 0 ? " " : '';
                    cammelCaseCity += firstLetter.toUpperCase() + remainder.toLowerCase();
                }

                zip.city = cammelCaseCity;
            });

            state.suggestedZips = suggested;
        },
        updateSearchText (state, searchText) {
            state.search_text = searchText;
        },
        updateOpenSpreadsheetForm (state, openForm) {
            state.spreadsheetFormOpen = openForm;
        },
        setPageLimit (state, newLimit) {
            state.pageLimit = newLimit;
        },
        setColumnAcvCollapsed (state, collapsed) {
            state.column_acv_collapsed = collapsed;
        },
        setColumnBobCollapsed (state, collapsed) {
            state.column_bob_collapsed = collapsed;
        },
        toggleVinSelection (state, vin) {
            if(state.selected_vins.includes(vin)) {
                let removeVin = JSON.parse(JSON.stringify(state.selected_vins));
                let removalIndex = removeVin.indexOf(vin);
                removeVin.splice(removalIndex, 1);

                state.selected_vins = removeVin;
            }
            else {
                let addedVin = JSON.parse(JSON.stringify(state.selected_vins));
                addedVin.push(vin);

                state.selected_vins = addedVin;
            }
        },
        setSortColumn (state, sortCol) {
            state.sort_col = sortCol;
        },
        setSortDirection (state, desc) {
            state.sort_reverse = desc;
        },
        getNextPageOfMatches (state) {
            state.current_page = state.current_page + 1;
        },
        setSpreadsheetGeneratingStatus (state, status) {
            state.generatingSpreadsheet = status;
        },
        setLoggingInStatus (state, status) {
            state.loggingIn = status;
        },
        updateLoginFormVisible (state, status) {
            state.loginFormVisible = status;
        },
        updateLoginErrorMsg (state, msg) {
            state.loginErrorMsg = msg;
        },
        setOpenGalleryImages (state, images) {
            state.openGalleryImages = images;
        },
        setVehicleGallerySelected (state, vehicle) {
            state.vdpVehicleSelected = vehicle;
            state.routerQueryStringChange = true;

            if(vehicle) {
                router.push({ path: '/vdp/' + vehicle.Year + "_" + vehicle.Make + "_" + vehicle.Model + "_" + vehicle.StockNumber, query: router.currentRoute._rawValue.query });
            }
            else {
                router.push({ path: '/', query: router.currentRoute._rawValue.query });
            }
        },
        setVehicleGallerySelectedFromRoute (state, vehicle) {
            state.vdpVehicleSelected = vehicle;
        },
        setProductSpecialistsList (state, psList) {
            state.productSpecialists = psList;
        },
        setQueryFailure (state, failure) {
            state.queryFailure = failure;
        },
        updateShowMobileVehicleResultsStatus (state, displayMobileResults) {
            state.displayMobileResults = displayMobileResults;
        },
        updateMobileKeyboradStatus (state, open) {
            state.mobileKeyboardOpen = open;
        },
        /*setWelcomePopupOpenStatus (state, open) {
            state.welcomePopupOpen = open;
        },*/
        routerQueryStringChangePushed (state, pushed) {
            state.routerQueryStringChange = pushed;
        },
        setBrowserButtonActionRunning (state, actionRunning) {
            state.browserButtonActionRunning = actionRunning;
        },
        increaseResizeCount(state) {
            state.resizeCount++;
        },
        toggleCrashMarkInitiated(state, vin) {
            state.crashMarkInitiated = vin;
        },
        setYoutubePlayerReadyState (state, youtubePlayerReady) {
            state.youtubePlayerReady = youtubePlayerReady;
        },
        startYoutubeVideo (state) {
            state.youtubeVideoPlaying = true;
        },
        closeYouTubeVideo (state) {
            var youTubeViewer = document.getElementById('youTube_video_viewport');
            
            if(youTubeViewer != null) {
                var playerDiv = document.createElement('div');
                playerDiv.id = "player";
                youTubeViewer.innerHTML = "";
                youTubeViewer.appendChild(playerDiv);

                state.youtubeVideoPlaying = false;
            }
        },
        setAppUrls (state, appUrls) {
            state.appUrls = appUrls;
        },
        setAutocheckDocHeight (state, docHeight) {
            state.autocheckDocHeight = docHeight;
        },
        setVehicleShareFormOpen (state, openStatus) {
            state.vehicleShareFormOpen = openStatus;
        },
        setSelectedDeliveryLocation (state, deliveryLocation) {
            state.defaultDeliveryLocation = deliveryLocation;
            window.localStorage.setItem('DeliveryLocation', JSON.stringify(deliveryLocation));
        },
        setDefaultDeliveryLocation (state, deliveryLocation) {
            state.defaultDeliveryLocation = deliveryLocation;
        },
        setDeliveryLocations (state, orderedAdessaLocations) {
            state.associatedAdessaDeliveryLocations = orderedAdessaLocations;
        },
        setDeliveryLocationSort (state, sortOrder) {
            state.deliveryLocationSort = sortOrder;
        },
        setCurrentDeliveryLocationDisplayOpenStatus (state, openStatus) {
            state.currentDeliveryLocationDisplayOpen = openStatus
        },
        setDeliveryLocationSelectOpenStatus (state, openStatus) {
            state.deliveryLocationSelectOpenStatus = openStatus;
        },
        setSearchScrollPosition (state, position) {
            state.searchScrollPosition = position;
        },
        updateCachedImagesForVehicle (state, matchCached) {
            let carToUpdate = JSON.parse(JSON.stringify(state.matches[matchCached.matchIndex]));

            carToUpdate.cached_thumbnail = matchCached.cachedImages.cached_thumbnail;
            carToUpdate.cached_primary_image = matchCached.cachedImages.cached_primary_image;

            state.matches.splice(matchCached.matchIndex, 1, carToUpdate);
        },
        removeBrokenImageFromGallery (state, indexToRemove) {
            state.openGalleryImages.splice(indexToRemove, 1);
        }
    },
    actions: {
        translateQueryStringFilters(context, toParams) {
            return new Promise((resolve, reject) => {
                try {
                    if(toParams.colors) {
                        let colors = [].concat(toParams.colors);
                        context.commit('updateFilterSelection', {name: 'colors', selected: colors});
                    }

                    if(toParams.models) {
                        let models = context.getters.translateQueryStringModels(toParams.models, toParams.makes);
                        context.commit('updateFilterSelection', {name: 'models', selected: models});
                    }

                    if(toParams.vehicle_types) {
                        let vehicle_types = [].concat(toParams.vehicle_types);
                        context.commit('updateFilterSelection', {name: 'vehicle_types', selected: vehicle_types});
                    }

                    if(toParams.makes) {
                        let makes = [].concat(toParams.makes);
                        context.commit('updateFilterSelection', {name: 'makes', selected: makes});
                    }

                    if(toParams.yearMin || toParams.yearMax) {
                        let yearmin = toParams.yearMin ? toParams.yearMin : context.getters.getAvailableFilters['year'].default.min;
                        let yearmax = toParams.yearMax ? toParams.yearMax : context.getters.getAvailableFilters['year'].default.max;

                        context.commit('updateFilterSelection', {name: 'year', selected: {min: yearmin, max: yearmax}});
                    }

                    if(toParams.searchText) {
                        context.commit('updateSearchText', toParams.searchText);
                    }

                    if(toParams.priceMin || toParams.priceMax) {
                        let pmin = toParams.priceMin ? toParams.priceMin : context.getters.getAvailableFilters['price'].default.min;
                        let pmax = toParams.priceMax ? toParams.priceMax : context.getters.getAvailableFilters['price'].default.max;

                        context.commit('updateFilterSelection', {name: 'price', selected: {min: pmin, max: pmax}});
                    }

                    if(toParams.acvMin || toParams.acvMax) {
                        let acvmin = toParams.acvMin ? toParams.acvMin : context.getters.getAvailableFilters['acv'].default.min;
                        let acvmax = toParams.acvMax ? toParams.acvMax : context.getters.getAvailableFilters['acv'].default.max;

                        context.commit('updateFilterSelection', {name: 'acv', selected: {min: acvmin, max: acvmax}});
                    }

                    if(toParams.bobMin || toParams.bobMax) {
                        let bobmin = toParams.bobMin ? toParams.bobMin : context.getters.getAvailableFilters['bob'].default.min;
                        let bobmax = toParams.bobMax ? toParams.bobMax : context.getters.getAvailableFilters['bob'].default.max;

                        context.commit('updateFilterSelection', {name: 'bob', selected: {min: bobmin, max: bobmax}});
                    }

                    if(toParams.mileageMin || toParams.mileageMax) {    
                        let mileagemin = toParams.mileageMin ? toParams.mileageMin : context.getters.getAvailableFilters['mileage'].default.min;
                        let mileagemax = toParams.mileageMax ? toParams.mileageMax : context.getters.getAvailableFilters['mileage'].default.max;

                        context.commit('updateFilterSelection', {name: 'mileage', selected: {min: mileagemin, max: mileagemax}});
                    }

                    if(toParams.searchText) {
                        context.commit('updateSearchText', toParams.searchText);
                    }

                    let optionsList = [];

                    if(toParams.optTransmission && toParams.optTransmission.length > 0) {
                        optionsList = optionsList.concat(context.getters.translateQueryStringTransmissionTypes(toParams.optTransmission));
                    }

                    if(toParams.optDrive && toParams.optDrive.length > 0) {
                        optionsList = optionsList.concat(context.getters.translateQueryStringDriveTypes(toParams.optDrive));
                    }

                    if(toParams.optCabType && toParams.optCabType.length > 0) {
                        optionsList = optionsList.concat(context.getters.translateQueryStringCabTypes(toParams.optCabType));
                    }

                    if(toParams.optDoors && toParams.optDoors.length > 0) {
                        optionsList = optionsList.concat(context.getters.translateQueryStringDoorTypes(toParams.optDoors));
                    }

                    if(toParams.optRearEntertainment) {
                        optionsList.push(context.getters.getAvailableFilters['options'].default['rear_entertainment']);
                    }

                    if(toParams.optNav) {
                        optionsList.push(context.getters.getAvailableFilters['options'].default['navigation']);
                    }

                    if(toParams.optMoonroof) {
                        optionsList.push(context.getters.getAvailableFilters['options'].default['moonroof']);
                    }

                    if(toParams.optThirdRow) {
                        optionsList.push(context.getters.getAvailableFilters['options'].default['third_row']);
                    }

                    if(toParams.optDiesel) {
                        optionsList.push(context.getters.getAvailableFilters['options'].default['diesel']);
                    }

                    if(toParams.optBCamera) {
                        optionsList.push(context.getters.getAvailableFilters['options'].default['backup_camera']);
                    }

                    if(toParams.optLeather) {
                        optionsList.push(context.getters.getAvailableFilters['options'].default['leather']);
                    }

                    if(optionsList.length > 0) {
                        context.commit('updateFilterSelection', {name: 'options', selected: optionsList});
                    }
                    
                    console.log("DOES SEARCH query have chanes " + context.getters.doesSearchQueryHaveChanges);
                    resolve();
                }
                catch(exception) {
                    console.log(exception);
                    reject();
                }
            });
        },
        determineUnFilteredQuery (context) {
            console.log("DETERMINE UNFILTERED QUERY");
            let unfiltered = true;

            if(context.state.search_text != "") {
                unfiltered = false;
            }

            if(unfiltered) {
                let filterNames = Object.keys(context.state.availableFilters);
                let count = 0

                while(unfiltered && count < filterNames.length) {
                    let filterToCheck = context.state.availableFilters[filterNames[count]];

                    if(filterToCheck.type == 'boolean') {
                        unfiltered = (!filterToCheck.selected || (filterToCheck.default == filterToCheck.selected));
                    }
                    else if(filterToCheck.type == 'range') {
                        unfiltered = (filterToCheck.selected.min == null || (filterToCheck.selected.min == filterToCheck.default.min)) && 
                                    (filterToCheck.selected.max == null || (filterToCheck.selected.max == filterToCheck.default.max));
                    }
                    else if(filterToCheck.type == 'array') {
                        unfiltered = (filterToCheck.selected.length == 0);
                    }
                    else if(filterToCheck.type == 'object') {
                        unfiltered = (Object.keys(filterToCheck.selected).length == 0);
                    }

                    count++;
                }
            }

            console.log("DETERMINED UNFILTERED TO BE " + unfiltered);

            context.state.initial_query = unfiltered;

            if(!unfiltered) {
                if(context.getters.isMobile) {
                    context.commit('updateShowMobileVehicleResultsStatus', true);
                }

                context.dispatch('updateSortColumnSortability', {col: 'BOB', sortable: true});
            }

            return unfiltered;
        },
        updateSortColumnSortability(context, sortabilityUpdate) {
            let sortColumnsCopy = JSON.parse(JSON.stringify(context.state.availableSortColumns));

            sortColumnsCopy[sortabilityUpdate.col].sortable = sortabilityUpdate.sortable;
            context.state.availableSortColumns = sortColumnsCopy;
        },
        updateDefaultSort (context, sortDefault) {
            context.state.default_sort_col = sortDefault;
            context.state.default_sort_reverse = context.getters.getAvailablSortColumnByName(sortDefault).defaultDirectionDesc;
        },
        setQuery (context) {
            console.log("SET QUERY " + JSON.stringify(context));
            context.state.query.initial_query = context.state.initial_query;
            context.state.query.dest_zip = context.state.dest_zip.zip;
            context.state.query.limit_count = context.state.pageLimit;
            context.state.query.skip_rows = context.getters.nextPageStart;
            context.state.query.vehicle_types = context.getters.getVechicleTypesSelected;
            context.state.query.makes = context.state.availableFilters['makes'].selected;
            context.state.query.models = context.getters.getSelectedOfObjectTypeFilterByName('models');
            context.state.query.colors = context.state.availableFilters['colors'].selected;
            context.state.query.priceMin = context.state.availableFilters['price'].selected.min;
            context.state.query.priceMax = context.state.availableFilters['price'].selected.max;
            context.state.query.mileageMin = context.state.availableFilters['mileage'].selected.min;
            context.state.query.mileageMax = context.state.availableFilters['mileage'].selected.max;
            context.state.query.yearMin = context.state.availableFilters['year'].selected.min;
            context.state.query.yearMax = context.state.availableFilters['year'].selected.max;
            context.state.query.bobMin = context.getters.isLoggedIn ? context.state.availableFilters['back_of_book'].selected.min : null;
            context.state.query.bobMax = context.getters.isLoggedIn ? context.state.availableFilters['back_of_book'].selected.max : null;
            context.state.query.buyNow = context.state.availableFilters['buy_now'].selected || !context.getters.isLoggedIn ? true : null;
            context.state.query.optMoonroof = context.state.availableFilters['options'].selected.includes(context.state.availableFilters['options'].default['moonroof']) ? true : null;
            context.state.query.optNav = context.state.availableFilters['options'].selected.includes(context.state.availableFilters['options'].default['navigation']) ? true : null;
            context.state.query.optLeather = context.state.availableFilters['options'].selected.includes(context.state.availableFilters['options'].default['leather'])  ? true : null;
            context.state.query.optTransmission = context.getters.getTransmisionSelected;
            context.state.query.optDrive = context.getters.getDriveSelected;
            context.state.query.optBCamera = context.state.availableFilters['options'].selected.includes(context.state.availableFilters['options'].default['backup_camera']) ? true : null;
            context.state.query.optDiesel = context.state.availableFilters['options'].selected.includes(context.state.availableFilters['options'].default['diesel']) ? true : null;
            context.state.query.optCabType = context.getters.getCabTypesSelected;
            context.state.query.optDoors = context.getters.getDoorsSelected;
            context.state.query.SortField = context.getters.getSortColumn;
            context.state.query.SortDirection = context.getters.getSortDirection;
            context.state.query.searchText = context.state.search_text;
            context.state.query.low_mileage = context.state.getLowMilageStatus;
            context.state.query.acvMin = context.getters.isLoggedIn ? context.state.availableFilters['acv'].selected.min : null;
            context.state.query.acvMax = context.getters.isLoggedIn ? context.state.availableFilters['acv'].selected.max : null;
            context.state.query.optThirdRow = context.state.availableFilters['options'].selected.includes(context.state.availableFilters['options'].default['third_row']) ? true : null;
            context.state.query.optRearEntertainment = context.state.availableFilters['options'].selected.includes(context.state.availableFilters['options'].default['rear_entertainment']) ? true : null;
            context.state.query.mMin = null; // DEFULT MIN MSCORE VALUE SET TO 0 IN ADMIN WHOLESALE CHANGE ONLY IF WHOLESALE UI MSCORE DIFFERENTIAL REQUIRED

            if(!context.getters.isBrowserButtonActionRunning) {
                context.dispatch('setNewRouteQueryString');
            }
            else {
                context.commit('setBrowserButtonActionRunning', false);
            }

            context.commit('notifySearchQueryChanges', false);
        },
        setNewRouteQueryString (context) {
            let newQueryString = {};

            for(var q = 0; q < Object.keys(context.state.query).length; q++) {
                let queryParam = Object.keys(context.state.query)[q];
                //console.log("Q IS " + queryParam + " WITH A VALUE OF " + context.state.query[queryParam]);

                if(!['initial_query', 'limit_count', 'skip_rows', 'SortField', 'SortDirection'].includes(queryParam)) {
                    let paramValue = context.state.query[queryParam];
                    
                    if(paramValue && ((typeof(paramValue) == 'object' && paramValue.length > 0) || (paramValue != ''))){
                        if(!['optTransmission', 'optDrive', 'optCabType', 'optDoors', 'headerGuestInfo', 'headerProductSpecialist','vehicle_types'].includes(queryParam)) {
                            newQueryString[queryParam] = context.state.query[queryParam];
                        }
                        else {
                            if(queryParam == 'optTransmission') {
                                newQueryString[queryParam] = paramValue;
                            }
                            else if(queryParam == 'optDrive') {
                                let driveOptions = [];
                                let optionDefaults = context.getters.getAvailableFilters.options.default;

                                if(typeof(paramValue) == 'object') {
                                    for(var d = 0; d < paramValue.length; d++) {
                                        let driveKey = Object.keys(optionDefaults).find(key => optionDefaults[key] === paramValue[d]);
                                        driveOptions.push(driveKey);
                                    }
                                }
                                else {
                                    let driveKey = Object.keys(optionDefaults).find(key => optionDefaults[key] === paramValue);
                                    driveOptions.push(driveKey);
                                }

                                newQueryString[queryParam] = driveOptions;
                            }
                            else if(queryParam == 'optCabType') {
                                let cabTypeOptions = [];
                        
                                if(paramValue.includes('Regular')) {
                                    cabTypeOptions.push('regular_cab');
                                }
                        
                                if(paramValue.includes('Crew')) {
                                    cabTypeOptions.push('crew_cab');
                                }
                        
                                if(paramValue.includes('Extended')) {
                                    cabTypeOptions.push('extended_cab');
                                }
                                
                                newQueryString[queryParam] = cabTypeOptions;
                            }
                            else if(queryParam == 'optDoors') {
                                let doorOptions = [];
                                
                                if(paramValue.includes('2')) {
                                    doorOptions.push('two_door');
                                }

                                if(paramValue.includes('3')) {
                                    doorOptions.push('three_door');
                                }

                                if(paramValue.includes('4')) {
                                    doorOptions.push('four_door');
                                }

                                newQueryString[queryParam] = doorOptions;
                            }
                            else if(queryParam == 'vehicle_types') {
                                let vehicleTypes = [];

                                if(paramValue.includes('Van')) {
                                    vehicleTypes.push('Van');
                                }
                    
                                if(paramValue.includes('Car') && !vehicleTypes.includes('Car')) {
                                    vehicleTypes.push('Car');
                                }
                    
                                if((paramValue.includes('SUV') || paramValue.includes('MPV')) && !vehicleTypes.includes('SUV')) {
                                    vehicleTypes.push('SUV');
                                }
                    
                                if((paramValue.includes('Truck') || paramValue.includes('Pickup'))  && !vehicleTypes.includes('Truck')){
                                    vehicleTypes.push('Truck');
                                }

                                newQueryString[queryParam] = vehicleTypes;
                            }
                        }
                    }
                }
            }

            context.commit('routerQueryStringChangePushed', true);

            if(router.currentRoute._rawValue.path == "/login") {
                router.push({path: '/', query: newQueryString});
            }
            else {
                console.log("NEW QUERY STRING " + JSON.stringify(newQueryString));
                router.push({ query: newQueryString});
            }
        },
        async pullListOfProductSpecialists (context) {
            const response = await config.AdminWholesaleAPI.get('psList');
            const json = response.data;

            context.commit('setProductSpecialistsList', json.productSpecialists);
        },
        async setDefaultsForAvailableFilters (context) { 
            let options = {};

            if(context.getters.isLoggedIn) {
                options = {headers: {Authorization: 'Bearer ' + context.getters.getAuthUser.token}};
            }

            const response = await config.clientAdminApi.get('v2/cars/auth-available-filters', options);
            const json = await response.data;

            console.log("SETTING DEFAULT FILTERS WITH JSON OBJECT FROM auth-available-filters ");// + JSON.stringify(json));
            
            context.commit('setFilterDefault', {name: "models", default: json.make_models_object, type: "object"});
            window.localStorage.setItem('MakeModels', JSON.stringify(json.make_models_object));
            context.commit('setFilterDefault', {name: "vehicle_types", default: ['Car', 'SUV', 'Truck', 'Van'], type: "array"});
            context.commit('setFilterDefault', {name: "makes", default: json.makes, type: "array"});
            context.commit('setFilterDefault', {name: "colors", default: json.exterior_colors, type: "array"});
            context.commit('setFilterDefault', {name: "price", default: {min: json.price_to_show_range[0], max: json.price_to_show_range[1]}, type: "range"});
            context.commit('setFilterDefault', {name: "mileage", default: {min: 0, max: json.mileage_range[1]}, type: "range"});
            context.commit('setFilterDefault', {name: "year", default: {min: json.year_range[0], max: json.year_range[1]}, type: "range"});
            context.commit('setFilterDefault', {name: "acv", default: {min: json.acv_range[0], max: json.acv_range[1]},  type: "range", authRequired: true});
            context.commit('setFilterDefault', {name: "back_of_book", default: {min: json.back_of_book_range[0], max: json.back_of_book_range[1]},  type: "range"});
            context.commit('setFilterDefault', {name: "buy_now", default: false,  type: "boolean"});
        },
        async runSearchQuery (context) {
            if(!context.getters.isQueryRunning) {
                context.commit('notifyQueryRunningState', true);
                //console.log("GOING TO RUN QUERY AFTER TEST");
                context.dispatch('determineUnFilteredQuery');
                context.dispatch('setQuery');

                try {
                    let options = {};

                    if(context.getters.isLoggedIn) {
                        options = {headers: {Authorization: 'Bearer ' + context.getters.getAuthUser.token}};
                    }

                    const response = await config.clientAdminApi.post('v2/cars/vehicle-search', context.getters.getQuery, options)
                                                .catch(function(error) {
                                                    if(error.response.status == 401 || error.response.status == 403) {
                                                        context.dispatch('logout');
                                                    }
                                                    else {
                                                        context.commit('setQueryFailure', true);
                                                    }
                                                });

                    if(response) {
                        const json = response.data;
    
                        context.commit('setQueryResults', json);
                    }
                }
                finally {
                    context.commit('notifyQueryRunningState', false);
                }
            }
        },
        async pageCurrentQuery (context) {
            if(!context.getters.doesSearchQueryHaveChanges && ((context.getters.getCurrentPage * context.getters.getPageLimit) < context.getters.getTotalMatches)) {
                context.commit('getNextPageOfMatches');
                context.dispatch('runSearchQuery');
            }
        },
        async getVehicleImageGallery (context, vin) {
            try {
                const response = await config.clientAdminApi.post('v2/images', {vin: vin});
                const json = response.data;
                
                json.pop(); // primary image is duplicated at end

                context.commit('setOpenGalleryImages', json);
            }
            catch(e) {
                console.log(e);
            }
        },
        async generateAdminSpreadsheet (context, input) {
            let spreadsheetQuery = context.getters.getQuery;

            Object.keys(input).forEach(function(field) {
                spreadsheetQuery[field] = input[field];
            });

            let options = {url: 'v2/cars/vehicle-search/excel', method: 'post', data: spreadsheetQuery, responseType: 'blob', headers: {Authorization: 'Bearer ' + context.getters.getAuthUser.token}};
            
            context.commit('setSpreadsheetGeneratingStatus', true);

            try {
                const response = await config.clientAdminApi.request(options)
                                            .catch(function(error) {
                                                if(error.response.status == 401) {
                                                    context.dispatch('logout');
                                                    router.push('/login');
                                                }
                                                else {
                                                    console.log(JSON.stringify(error.response));
                                                }
                                            });

                if(response) {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }));
                    const link = document.createElement('a');

                    link.href = url;
                    link.setAttribute('download', 'search.online.car_' + input['headerGuestInfo'].replace(/\s+/g, '') + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                
                    link.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
            catch(e) {
                console.log(e);
            }
            finally {
                context.commit('setSpreadsheetGeneratingStatus', false);
            }
        },
        async searchForZip (context) {
            const response = await config.clientAdminApi.post('v2/cars/zip-search', {searchstring: context.getters.getDestZipSearch});
            const json = response.data;

            context.commit('setSuggestedZips', json);
        },
        async clearAllFilterSelections (context) {
            for(let f in context.state.availableFilters) {
                let filterType = context.state.availableFilters[f].type;
                
                if(filterType == "object") {
                    context.state.availableFilters[f].selected = {};
                    context.state.availableFilters[f].available = JSON.parse(JSON.stringify(context.state.availableFilters[f].default));
                }
                else if(filterType == "range") {
                    context.state.availableFilters[f].selected = {min: null, max: null};
                }
                else if( filterType == "array") {
                    context.state.availableFilters[f].selected = [];
                }
                else if(filterType == "quick") {
                    context.state.availableFilters[f].selected = {};
                }
                else if(filterType == "boolean") {
                    context.state.availableFilters[f].selected = false;
                }
            }

            context.state.sort_col = null; 
            context.state.sort_reverse = null; 
            context.state.search_text = "";
            context.state.selected_vins = [];

            context.commit('notifySearchQueryChanges', true);
        },
        async authenticateUser (context, loginFormData) {
            context.commit('setLoggingInStatus', true);

            try {
                const response = await config.clientAdminApi.post('v2/user/login', loginFormData);
                const json = response.data;

                if(json.token) {
                    let auth = jwt.decode(json.token);
                    
                    context.state.authUser = auth.data; 
                    context.state.authUser.userId = auth.sub;
                    context.state.authUser.token = json.token; 
                    
                    window.localStorage.setItem('socAuthUser', context.getters.getAuthUser.token);
                    
                    context.commit('setLoggingInStatus', false);
                    context.commit('updateLoginFormVisible', false); 
                    context.state.loggedIn = true;
                    
                    context.dispatch('setDefaultsForAvailableFilters');
                    context.commit('notifySearchQueryChanges', true);

                    if(router.currentRoute._rawValue.params.vehicleInfo) {
                        let crashRequested = (router.currentRoute._rawValue.params.crashed && router.currentRoute._rawValue.params.crashed == 'crashed');

                        context.dispatch('getVehicleFromURL', {vehicleInfo: router.currentRoute._rawValue.params.vehicleInfo, crashRequest: crashRequested});
                    }
                }
                else if(json.error) {
                    context.commit('updateLoginErrorMsg', json.message);
                    context.commit('setLoggingInStatus', false);
                }
            }
            catch(e) {
                console.log(" ERROR !!! " + e);
                context.commit('setLoggingInStatus', false);
            }
        },
        async authenticationRefresh (context) {
            let options = null;

            if(context.getters.isLoggedIn) {
                options = {headers: {Authorization: 'Bearer ' + context.getters.getAuthUser.token}};
            }

            try {
                const response = await config.clientAdminApi.post('v2/user/refresh-token', null, options)
                                            .catch(function(error) {
                                                if(error.response.status == 401) {
                                                    context.dispatch('logout');
                                                }
                                                else {
                                                    console.log(JSON.stringify(error.response));
                                                }
                                            });
                
                if(response) {
                    const json = response.data;

                    if(json.token) {
                        context.state.authUser.token = json.token; 
                        window.localStorage.setItem('socAuthUser', context.getters.getAuthUser.token);
                    }
                }
            }
            catch(e) {
                console.log(" ERROR !!! refresh login failed " + e);
            }
        },
        async veriryUserAuthenticated (context, browserData) {
            if(browserData) {
                let auth = jwt.decode(browserData);
                console.log("AUTH DATA EXISTS AND EXPIRES " + auth.exp + " VS CURRENT TIMESTAMP " + Math.floor((new Date()) / 1000));
                
                if(Math.floor((new Date()) / 1000) < auth.exp) {
                    context.state.authUser = auth.data; 
                    context.state.authUser.userId = auth.sub;
                    context.state.authUser.token = browserData;
                    context.state.loggedIn = true;

                    if((Math.floor((new Date()) / 1000) < (auth.exp - 2)) && (Math.floor((new Date()) / 1000) > (auth.exp - (60 * 60 * 24 * 6)))) {
                        console.log("token needs a refresh");
                        context.dispatch('authenticationRefresh');
                    }
                }
                else {
                    console.log("AUTH IN CONTEXT HAS EXPIRED");
                    context.dispatch('logout');
                }
            }
            else {
                console.log("NO AUTH IN CONTEXT");
                context.dispatch('logout');
            }
        },
        logout (context) {
            console.log("LOGGING OUT");
            window.localStorage.removeItem('socAuthUser');
            context.state.authUser = {};

            if(context.state.loggedIn) {
                context.state.loggedIn = false;
                context.dispatch('setDefaultsForAvailableFilters');
                context.commit('notifySearchQueryChanges', true);
            }
        },
        applyQuickFilterSelected (context, quickFilterSelected) {
            context.state.availableFilters['quick_filters'].selected = quickFilterSelected;
            
            for(let qf in context.state.availableFilters) {
                let filter = context.state.availableFilters[qf];
                let type = filter.type;
                 
                if(quickFilterSelected.filters[filter.name]) {
                    if(type == 'range' && (!quickFilterSelected.filters[filter.name].min || !quickFilterSelected.filters[filter.name].max)) {
                        let quickSelected = {};
                        
                        quickSelected.min = quickFilterSelected.filters[filter.name].min ? quickFilterSelected.filters[filter.name].min : filter.default.min;
                        quickSelected.max = quickFilterSelected.filters[filter.name].max ? quickFilterSelected.filters[filter.name].max : filter.default.max;

                        context.state.availableFilters[filter.name].selected = quickSelected;
                    }
                    else {
                        context.state.availableFilters[filter.name].selected = quickFilterSelected.filters[filter.name];
                    }
                }
                else {
                    if(type == 'range') {
                        context.state.availableFilters[filter.name].selected = filter.default;
                    }
                    else if(type == 'array') {
                        context.state.availableFilters[filter.name].selected = [];
                    }
                    else if(type == 'object') {
                        context.state.availableFilters[filter.name].selected = {};
                    }
                    else if(type == 'boolean') {
                        context.state.availableFilters[filter.name].selected = false;
                    }
                }
            }

            context.commit('notifySearchQueryChanges', true);
        },
        openAppInSeperateWindow(context, appAddress) {
            var appWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
            window.open(appAddress, "_blank", appWindowFeatures);
        },
        async getVehicleFromURL(context, vdp) {//vehicleId, crashRequested) {
            let vehicleId = vdp.vehicleInfo;
            let crashRequested = vdp.crashRequest;
            let vehicleVin = context.getters.isVin(vehicleId) ? [vehicleId] : [];
            let vehicleStockNumbers = [];
            let vehicleMakes = [];
            let vehicleModels = [];
            let vehicleYear = null;

            if(!vehicleVin || vehicleVin.length == 0) {
                let vehicleIdParts = vehicleId.split("_");
                
                vehicleYear = parseInt(vehicleIdParts[0]);
                vehicleMakes = [vehicleIdParts[1]];
                vehicleModels = [vehicleIdParts[2]];
                vehicleStockNumbers = [vehicleIdParts[3]];
            }

            let retrieveVehicleQuery = {
                vins: vehicleVin,
                stockNumbers: vehicleStockNumbers,
                makes: vehicleMakes,
                models: vehicleModels,
                yearMin: vehicleYear,
                yearMax: vehicleYear,
                dest_zip: context.getters.getDestZip.zip,
                limit_count: 1,
                skip_rows: 0
            }

            console.log("retrievVehicleQuery " + JSON.stringify(retrieveVehicleQuery));

            try {
                let options = {};

                if(context.getters.isLoggedIn) {
                    options = {headers: {Authorization: 'Bearer ' + context.getters.getAuthUser.token}};
                }

                const response = await config.clientAdminApi.post('v2/cars/vehicle-search', retrieveVehicleQuery, options)
                                            .catch(function(error) {
                                                if(error.response.status == 401 || error.response.status == 403) {
                                                    context.dispatch('logout');
                                                }
                                            });

                if(response) {
                    const vehicleFound = response.data.results[0];

                    if(vehicleFound) { 
                        context.commit('setVehicleGallerySelectedFromRoute', vehicleFound);
                        context.dispatch('getVehicleImageGallery', vehicleFound.VIN);

                        if(crashRequested) {
                            if(context.getters.isLoggedIn) {
                                context.commit('toggleCrashMarkInitiated', vehicleFound);
                            }
                            else {
                                context.commit('updateLoginFormVisible', true);
                            }
                        }
                    }
                    else {
                        context.commit('setMessageToGuest', (vehicleId + " is no longer available"));
                        context.commit('setVehicleGallerySelected', null);
                    }
                }
            }
            catch(e) {
                console.log(" ERROR !!! refresh login failed " + e);
            }
        },
        async crashVehicle (context) {
            let msg = '';
            
            if(context.getters.hasCrashMarkBeenInitiated) {
                let setCrashVehicleURL = "v2/cars/markCrashed";
                let vin = context.getters.getCrashedVehicle.VIN;
                let stocknumber = context.getters.getCrashedVehicle.StockNumber;
                let options = null;
                let vinIndex = -1;
                let i = 0;

                while((i < context.getters.getMatches.length) && (vinIndex < 0)) {
                    let matchedCar = context.getters.getMatches[i];

                    if(matchedCar.VIN == vin) {
                        vinIndex = i;
                    }

                    i++;
                }
    
                if(context.getters.isLoggedIn) {
                    options = {headers: {Authorization: 'Bearer ' + context.getters.getAuthUser.token}};

                    try {
                        const response = await config.clientAdminApi.post(setCrashVehicleURL, {id: vin, caller: 'search.online.cars'}, options)
                                                .catch(function(error) {
                                                    msg = 'Error marking vehicle for deletion.';
                                                    
                                                    if(error.response.status == 401) {
                                                        context.dispatch('logout');
                                                        router.push('/login');
                                                    }
                                                });
                        if(response) {
                            if(vinIndex >= 0) {
                                let removeMatch = JSON.parse(JSON.stringify(context.state.matches));

                                removeMatch.splice(vinIndex, 1);

                                context.state.matches_total = context.state.matches_total - 1;
                                context.state.vehiclesRemoved++;
                                context.state.matches = removeMatch;
                            }

                            msg = stocknumber + " has been removed from the system";
                            context.commit('setVehicleGallerySelected', null);
                            context.commit('setOpenGalleryImages', []);
                        }
                        else {
                            msg = "Error marking vehicle for deletion. No repsponse from server.";
                        }
                    }
                    catch(e) {
                        msg = "Error marking vehicle for deletion. No repsponse from server.";
                        console.log(JSON.stringify(e));
                    }
                }
                else {
                    msg = "Please log in to mark a vehicle for deletion";
                }
            }
            else {
                msg = "No vehicle has been selected for removal from the system.";
            }

            context.commit('toggleCrashMarkInitiated', null);
            context.commit('setMessageToGuest', msg);
        },
        async getAppUrls (context) {
            try {
                const response = await config.clientAdminApi.get("v2/cars/appurls");

                if(response) {
                    context.commit('setAppUrls', response.data);
                }
            }
            catch(e) {
                console.log(" ERROR " + e);
            }
        },
        async getDeliveryLocations (context) {
            let postData = { zipGroundZero: context.getters.getDestZip.zip };

            try {
                const response = await config.clientAdminApi.post("v2/cars/delivery-locations-with-distance", postData);
                
                if(response) {
                    context.commit('setDeliveryLocations', response.data);

                    let closest = response.data[0];
                    
                    if(!window.localStorage.DeliveryLocation || window.localStorage.DeliveryLocation != "") {
                        response.data.forEach(function(location) {
                            if(location.distance < closest.distance) {
                                closest = location;
                            }
                        });
                        console.log("CLOSEST FOUND " + JSON.stringify(closest));
                        context.commit('setDefaultDeliveryLocation', closest);
                    }
                }

            }
            catch(e) {
                console.log("ERROR " + e);
            }
        },
        updateDestZip (context, zip) {
            context.state.dest_zip = zip;
            window.localStorage.DestZip = JSON.stringify(zip);
            //context.commit('setDefaultDeliveryLocation', 0);
            window.localStorage.removeItem('DeliveryLocation');
            context.dispatch('getDeliveryLocations'); //OrderedByDistance');
        },
    }
});

const app = createApp(App);
app.use(router);
app.use(store);
app.use(gtag, {config: { id: 'UA-100329758-2' }, router });

router.isReady().then(() => {
    app.mount('#app');
});
